module.exports = __webpack_public_path__ + "static/media/userProfileBg.2a6f7779.png";